import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {connectToJSContext} from "../utils.jsx";

import Footer from "../footer/index.jsx";
import Navigation from "../navigation/index.jsx";
import {NewsOrgCustomContent, NewsUserCustomContent} from "../custom_content/index.jsx";
import {NewsHero} from "../hero/index.jsx";
import ContactForm from "../contact_form/index.jsx";
import PostList from "../post_list/index.jsx";
import { NEWS_PAGE } from '../constants';

const NewsPage = ({showOrgCustomContent, showUserCustomContent, moduleOrder, limit}) => {
    const mapModuleNameToComponent = {
        [NEWS_PAGE.MODULES.NEWS_HERO]: NewsHero,
        [NEWS_PAGE.MODULES.NEWS_ORG_CUSTOM_CONTENT]: showOrgCustomContent && NewsOrgCustomContent,
        [NEWS_PAGE.MODULES.NEWS_USER_CUSTOM_CONTENT]: showUserCustomContent && NewsUserCustomContent,
        [NEWS_PAGE.MODULES.NEWS_CONTACT_FORM]: ContactForm,
        [NEWS_PAGE.MODULES.NEWS]: PostList
    };

    const componentsWithExtraProps = {
        [NEWS_PAGE.MODULES.NEWS]: { limit }
    };

    return (
        <div>
            <Navigation currentPage={'news'}/>
            <div id="maincontent" role="main">
                {moduleOrder.map((moduleName, i) => {
                    const Component = mapModuleNameToComponent[moduleName];
                    if(_.has(componentsWithExtraProps, moduleName)) {
                        return Component && <Component {...componentsWithExtraProps[moduleName]} key={i} />;
                    }
                    return Component && <Component key={i} />;
                })}
            </div>
            <Footer />
        </div>
    );
};

NewsPage.defaultProps = {
    moduleOrder: [
        NEWS_PAGE.MODULES.NEWS_HERO,
        NEWS_PAGE.MODULES.NEWS_ORG_CUSTOM_CONTENT,
        NEWS_PAGE.MODULES.NEWS_USER_CUSTOM_CONTENT,
        NEWS_PAGE.MODULES.NEWS_CONTACT_FORM,
        NEWS_PAGE.MODULES.NEWS
    ]
};

NewsPage.PropTypes = {
    showOrgCustomContent: PropTypes.bool.isRequired,
    showUserCustomContent: PropTypes.bool.isRequired,
    moduleOrder: PropTypes.arrayOf(
        PropTypes.oneOf(_.values(NEWS_PAGE.MODULES)).isRequired
    )
};

const mapStateToProps = (state) => ({
    showOrgCustomContent: !_.isEmpty(state.theme_data.news_page.custom_content),
    showUserCustomContent: !_.isEmpty(state.profile.news_custom_content),
    limit: +state.theme_data.news_page.max_number_of_posts || undefined,
    moduleOrder: state.theme_data.news_page.modules &&
        _.flatten(_.pluck(state.theme_data.news_page.modules, 'module'))
});

export default connectToJSContext(mapStateToProps)(NewsPage);




// WEBPACK FOOTER //
// ./components/news_page/index.jsx